import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { GETTERS as LEADERBOARD_GETTERS } from '@/store/leaderboard';

@Component({
  name: 'CmgLeaderboardBadgesEarned',
})
export default class CmgLeaderboardBadgesEarned extends Vue {

  get isInErrorState(): boolean {
    return this.$appStore.state.leaderboard.isInErrorState;
  }

  get isInZeroState(): boolean {
    return this.orderCount === 0;
  }

  get orderCount(): number {
    return this.$appStore.getters[LEADERBOARD_GETTERS.ORDER_COUNT];
  }   
  
  get badgesEarned(): number {
      return this.$appStore.state.leaderboard.statistics.badgesEarned;
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get whiteBoxImg(): string | undefined {
    return !this.isMobile
      ? this.$appStore.state.cms.images.loyalty.leaderboardWhiteBoxBadgesEarned.desktop
      : this.$appStore.state.cms.images.loyalty.leaderboardWhiteBoxBadgesEarned.mobile;
  }
}
